export const PIPELINE_STAGES = [
  { key: 'imported', label: 'Imported', color: 'bg-blue-500' },
  { key: 'scraped', label: 'Scraped', color: 'bg-gray-500' },
  { key: 'scoring', label: 'Scoring', color: 'bg-yellow-500' },
  { key: 'qualified', label: 'Qualified', color: 'bg-green-500' },
  { key: 'disqualified', label: 'Disqualified', color: 'bg-red-400' },
  { key: 'contacted', label: 'Contacted', color: 'bg-purple-500' },
  { key: 'replied', label: 'Replied', color: 'bg-teal-500' },
  { key: 'converted', label: 'Converted', color: 'bg-emerald-600' },
  { key: 'lost', label: 'Lost', color: 'bg-red-600' },
];

export const STAGE_MAP = Object.fromEntries(
  PIPELINE_STAGES.map(s => [s.key, { label: s.label, color: s.color }])
);
